import React, {PropsWithChildren} from 'react';
import Button from "react-bootstrap/Button";
import {getCurrencySymbol} from "./AmountSpan";

export default function OptionButton({ children, selected, onClick = undefined }: PropsWithChildren<{
    selected: boolean; onClick?: () => void;
}>) {
    return (
        <Button
            className={`flex-grow-1 text-dark d-flex flex-column py-2 px-4 rounded-4 align-items-center border border-1 ${selected ? 'border-neutral-700 border-2': 'border-1 border-neutral-400'} mt-2`}
            variant=""
            onClick={onClick}
        >
            {children}
        </Button>
    );
}

function Discount({ mainPriceAmount, downSellAmount, currency }: {
    currency: 'eur' | 'usd';
    mainPriceAmount: number;
    downSellAmount: number;
}) {
    const annualDownSellAmount = 12 * downSellAmount;
    const savingInAbsolute = ((annualDownSellAmount - mainPriceAmount) / 100);
    const savingInPercentage = Math.round(savingInAbsolute * 100 / annualDownSellAmount * 100);

    return (
        <div className="text-success text-sm">
            {savingInAbsolute < 20
                ? `Save ${savingInPercentage}%!`
                : <>{getCurrencySymbol(currency)}{savingInAbsolute.toFixed(2)} savings!</>}
        </div>
    )
}

OptionButton.Discount = Discount;
